import AuthService from "../login/auth.service";
import { cuentas, comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class DebitoAutomaticoService {
  async obtenerDebitosSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async habilitarInhabilitarDebito(cuenta, numeroModulo, identificador, opcion, importeFijo, porcentaje) {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;
    var data = JSON.stringify({
      // idPersona: persona,
      idAhorro: cuenta,
      modalidad: numeroModulo,
      numeroDocumento: identificador,
      opcion: opcion,
      importeFijo: importeFijo,
      porcentaje: porcentaje,
      canal: "WEB",

    });


    var config = {
      method: "post",
      url: cuentas + "debito-automatico",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }


  async obtenerCuentasDebitoSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/cambiar-cuenta",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }


  async confirmarCambioCuenta(cuenta) {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;
    var data = JSON.stringify({
      // idPersona: persona,
      idAhorro: cuenta,
      modalidad: null,
      numeroDocumento: null,
      opcion: "U",
      importeFijo: null,
      porcentaje: null,
      canal: "WEB",

    });


    var config = {
      method: "post",
      url: cuentas + "debito-automatico",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //  console.log(data)
    return await axios(config);
  }



  async obtenerPrestamosSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/creditos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async obtenerCuentaDebitoSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/cuentas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async obtenerTarjetaDebitoSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/tarjetas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async obtenerRuedaSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/ruedas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async obtenerAhorroProgramadoSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: cuentas + "debito-automatico/ahorros-programados",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    //console.log(usuario)
    return await axios(config);
  }

  async confirmarDebitoAutomatico(cuenta, modalidad, documento, importe, porcentaje) {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;
    var data = JSON.stringify({
      // idPersona: persona,
      idAhorro: cuenta,
      modalidad: modalidad,
      numeroDocumento: documento,
      opcion: "C",
      importeFijo: importe,
      porcentaje: porcentaje,
      canal: "WEB",

    });


    var config = {
      method: "post",
      url: cuentas + "debito-automatico",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }

  async descagarComprobanteCambioCuenta(titulo, nroOperacion, nombreSocio, nroSocio, cuentaDebito) {
    
    var _url = comprobantes + "comprobantes/v2/modificacion-cuenta-debito-automatico";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nombreSocio: nombreSocio,
      nroSocio: nroSocio,
      cuentaAhorroOrigen: cuentaDebito
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

  async descagarComprobanteAutorizacionDebito(titulo, nroOperacion, nombreSocio, nroSocio, cuentaDebito, tipo, identificador) {
    
    var _url = comprobantes + "comprobantes/v2/autorizacion-debito-automatico";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nombreSocio: nombreSocio,
      nroSocio: nroSocio,
      cuentaAhorroOrigen: cuentaDebito,
      tipo: tipo,
      identificador: identificador
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async descagarComprobanteAutorizacionDebitoTarjeta(titulo, nroOperacion, nombreSocio, nroSocio, cuentaDebito, tipo, identificador, montoPorcentaje) {
    
    var _url = comprobantes + "comprobantes/v2/autorizacion-debito-automatico-tarjeta";
    //console.log("###################");
    //console.log(montoPorcentaje);
    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nombreSocio: nombreSocio,
      nroSocio: nroSocio,
      cuentaAhorroOrigen: cuentaDebito,
      tipo: tipo,
      identificador: identificador,
      montoPorcentaje: montoPorcentaje
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

  async descagarComprobanteIA(tipoIA, nroOperacion, nombreSocio, nroSocio, cuentaDebito, tipo, vencimiento, montoDescontar, identificador) {
    
    var _url = comprobantes +"comprobantes";
    var titulo = "";
    if(tipoIA === "I"){
      _url += "/v2/inactivacion-debito-automatico";
      titulo = "Inactivación de Débito Automático";
    }else{
      _url += "/v2/activacion-debito-automatico";
      titulo = "Activación de Débito Automático";
    }

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nombreSocio: nombreSocio,
      nroSocio: nroSocio,
      cuentaAhorroOrigen: cuentaDebito,
      tipo: tipo,
      vencimiento: vencimiento,
      monto: montoDescontar,
      identificador: identificador
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }

}
export default new DebitoAutomaticoService();
